import { ApprovalDeal } from 'ts/interfaces/approvalDeal.interface'

/**
 * Opens the decision page in a new tab for the given approval deal
 * @param deal - The approval deal object
 */
export const openDecisionPage = (deal: ApprovalDeal): void => {
  const url = deal?.decisionPagePath ?? null
  if (url) {
    const newWindow = window.open(url, '_blank')
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
      console.error('Failed to open Decision Page. Please check popup blocker settings.')
      // Consider showing user-facing alert
    }
  }
}
